export enum ReferenceItemType {
    FLO_LEVEL = 'flo-level',
}
/**
 * Model to hold a reference item
 */
export class ReferenceItem {
    public id: string = null;
    public name: string = null;
    public type: ReferenceItemType = null;

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'referenceItem';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.name = this.name;
        json.data.attributes.type = this.type;

        return JSON.stringify(json);
    }

    public clone(): ReferenceItem {
        const clone: ReferenceItem = new ReferenceItem();
        clone.id = this.id;
        clone.name = this.name;
        clone.type = this.type;

        return clone;
    }

    /**
     * Deserialize to json api format
     */
    public deserialize(json: any): ReferenceItem {
        const data: any = json.data || json;
        const attrs: any = data.attributes || {};

        this.id = data.id;
        this.name = attrs.name;
        this.type = attrs.type;

        return this;
    }
}
